import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { CreateNoticeParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  CreateNoticeRepository,
  CreateNoticeResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum CreateNoticeState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: CreateNoticeState;
  message: string;
}

const initialState: InitialState = {
  status: CreateNoticeState.initial,
  message: "",
};

export const createNotice = createAsyncThunk(
  "createNotice",
  async (param: CreateNoticeParam, { rejectWithValue }) => {
    try {
      const response: CreateNoticeResponse = await CreateNoticeRepository(
        param
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

export const createNoticeSlice = createSlice({
  name: "createNotice",
  initialState,
  reducers: {
    resetCreateNotice: (state) => {
      state.status = CreateNoticeState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNotice.pending, (state) => {
        state.status = CreateNoticeState.inProgress;
      })
      .addCase(createNotice.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = CreateNoticeState.success;
          state.message = message;
        }
      })
      .addCase(createNotice.rejected, (state, action) => {
        state.status = CreateNoticeState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectCreateNotice = (state: RootState) => state.createNotice;
export const { resetCreateNotice } = createNoticeSlice.actions;
export default createNoticeSlice.reducer;
